<div class="layout-wrapper" (click)="onLayoutClick()"
     [ngClass]="{'menu-layout-static': layoutMode !== 'overlay',
                'menu-layout-overlay': layoutMode === 'overlay',
                'layout-menu-overlay-active': overlayMenuActive,
                'menu-layout-slim': layoutMode === 'slim',
                'menu-layout-horizontal': layoutMode === 'horizontal',
                'layout-menu-static-inactive': staticMenuDesktopInactive,
                'layout-menu-static-active': staticMenuMobileActive,
                'p-input-filled': app.inputStyle === 'filled',
                'p-ripple-disabled': !app.ripple}">

    <app-cbet-topbar [roles]="roles"></app-cbet-topbar>

    <div #menuContainer class="layout-menu-container" [ngClass]="{'layout-menu-dark': app.darkMode}"
         (click)="onMenuClick($event)">
        <app-cbet-menu [roles]="roles"></app-cbet-menu>
    </div>

    <div class="layout-main" [style.padding-top.px]="mainPaddingTop">
        <app-cbet-breadcrumb></app-cbet-breadcrumb>

        <app-aviso-deuda></app-aviso-deuda>

        <router-outlet></router-outlet>
    </div>

    <app-footer></app-footer>

    <app-ai-chat-launcher></app-ai-chat-launcher>

    <div class="layout-mask"></div>
    <app-theme-toggle [floating]="true"></app-theme-toggle>
</div>
